import type { Sort, SortDirection } from '@library/types/utils';

export const getSortDirection = <T extends string = string>({
  column,
  sort
}: {
  column: T;
  sort: Sort<T>;
}): SortDirection => {
  const { sortBy, sortDirection } = sort;

  if (sortBy === column) {
    switch (sortDirection) {
      case 'asc':
        return 'desc';
      case 'desc':
        return 'none';
      default:
        return 'asc';
    }
  }

  return 'asc';
};
